<!-- Header -->
<div class="modal-header justify-content-between">
  <h4 class="modal-title header-13">{{ isEdit ? 'Update Application' : 'Add New Application' }}</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="isActive
        ? 'assets/images/virtusa-icons/close-dark.svg'
        : 'assets/images/virtusa-icons/close.svg'"
    />
  </button>
</div>

<!-- Body -->
<div class="modal-body">

  <!-- Top fields via dynamic form -->
  <app-dynamic-form [form]="form" [formFields]="fields"></app-dynamic-form>

  <!-- Role-Based Credentials — Web only -->
  @if (isWebType) {
    <div class="aba-cred-section">
      <div class="aba-cred-header">
        <span class="aba-cred-title">Role-Based Credential(s)</span>
        <button type="button" class="aba-add-cred-btn" (click)="addCredential()">
          Add Credential(s)
        </button>
      </div>

      <app-zorro-table
        [columns]="credentialColumns"
        [data]="credentialRows"
        [options]="credentialOptions"
        (handleActions)="handleCredentialActions($event)"
      ></app-zorro-table>
    </div>
  }
</div>

<!-- Footer -->
<div class="modal-footer">
  <div class="d-flex justify-content-end m-0">
    <button class="btn-accello-secondary mx-2 open-btn" (click)="activeModal.dismiss('Cross click')">
      Cancel
    </button>
    <button class="btn-accello-primary-light open-btn" (click)="submit()" [disabled]="!isFormValid">
      {{ isEdit ? 'Update' : 'Save' }}
    </button>
  </div>
</div>
